import React, { useState, useMemo } from "react";
import EmployeeStockTab from "./employee_stocks";
import BranchStockeTab from "./Branch_stock";
import { Tab, Nav } from "react-bootstrap";
const BranchStockTab = () => {
  return (
    <>
      <Tab.Container defaultActiveKey="home-tab">
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="home-tab">Branch</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="profile-tab">Employee</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="contact-tab">Report</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="home-tab">
            <BranchStockeTab />
          </Tab.Pane>
          <Tab.Pane eventKey="profile-tab">
            <EmployeeStockTab />
          </Tab.Pane>
          <Tab.Pane eventKey="contact-tab">
            <p>Report</p>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default BranchStockTab;
